import { RangePickerProps } from 'antd/es/date-picker';
import { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import dayjs from 'utils/moment/dayjsConfig';

/** Note: Hook trả về ant design DatePicker disabledDate, dùng trong form có 2 field formDate - toDate */
const useGetDisableDateRange = (fromDate: Dayjs, toDate: Dayjs) => {
  const disabledFromDate: RangePickerProps['disabledDate'] = useCallback(
    (day: Dayjs) => {
      return Boolean(day && toDate && day.isSameOrAfter(dayjs(toDate), 'day'));
    },
    [toDate]
  );

  const disabledToDate: RangePickerProps['disabledDate'] = useCallback(
    (day: Dayjs) => {
      return Boolean(
        day && fromDate && day.isSameOrBefore(dayjs(fromDate), 'day')
      );
    },
    [fromDate]
  );

  return {
    disabledFromDate,
    disabledToDate,
  };
};

export default useGetDisableDateRange;
